// src/components/ThemeToggle.jsx
import React, { useEffect, useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { MdComputer } from 'react-icons/md';
import { FiSun, FiMoon } from 'react-icons/fi';

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  const options = [
    { value: 'system', icon: <MdComputer />, label: 'System' },
    { value: 'light', icon: <FiSun />, label: 'Light' },
    { value: 'dark', icon: <FiMoon />, label: 'Dark' },
  ];

  return (
    <div
      className="flex rounded-full overflow-hidden"
      style={{
        border: '1px solid var(--border)',
        backgroundColor: 'var(--bg)',
      }}
    >
      {options.map(opt => (
        <button
          key={opt.value}
          onClick={() => setTheme(opt.value)}
          className="p-2 text-sm transition cursor-pointer"
          style={{
            backgroundColor:
              theme === opt.value ? 'var(--text)' : 'transparent',
            color: theme === opt.value ? 'var(--bg)' : 'var(--muted)',
          }}
          onMouseEnter={e => {
            if (theme !== opt.value) {
              e.currentTarget.style.backgroundColor = 'var(--border)';
              e.currentTarget.style.color = 'var(--text)';
            }
          }}
          onMouseLeave={e => {
            if (theme !== opt.value) {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = 'var(--muted)';
            }
          }}
          aria-label={`Switch to ${opt.label} theme`}
        >
          {opt.icon}
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
